import { Box } from '@mui/material';
import { LabelBadge } from '../../../../shared/components/common/labelBadge';

const getTitle = (cell) => {
  let languages = cell?.row?.original?.languages || [];
  if (languages?.length) {
    return languages[0].title;
  }
};

export function InitializeComparisonColumns() {
  return [
    {
      header: 'ID',
      accessorKey: 'id',
    },
    {
      header: 'Title',
      accessorKey: 'title',
      Cell: ({ cell }) => {
        return (
          <Box className="flex flex-auto justify-start items-center">
            <Box>{getTitle(cell)}</Box>
          </Box>
        );
      },
    },
    {
      header: 'Slug Name',
      accessorKey: 'slug',
    },
    {
      header: 'Visibility',
      accessorKey: 'published',
      Cell: ({ cell }) => {
        return (
          <Box className="flex flex-auto justify-start items-center">
            {cell?.getValue() ? (
              <LabelBadge label={'Published'}></LabelBadge>
            ) : (
              <LabelBadge
                classList={'!bg-red-200 !text-red-500'}
                label={'Draft'}></LabelBadge>
            )}
          </Box>
        );
      },
    },
  ];
}
